module.exports = __webpack_public_path__ + "static/img/celoscope-20.b930a36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-20.jpg
// module id = 0cLl
// module chunks = 51